export const TIMEFRAME_PERSIST_PROP = "timeFrameOption";
export const COMPARETO_PERSIST_PROP = "compareToOption";
